import { render } from "./UnPaidSBP.vue?vue&type=template&id=81086c5c"
import script from "./UnPaidSBP.vue?vue&type=script&lang=js"
export * from "./UnPaidSBP.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__